window.timberSlider = window.timberSlider || {};

timberSlider.cacheSelectors = function () {
  timberSlider.cache = {
    // Home Page
    $slider: $('.flexslider')
  }
};

timberSlider.init = function () {
  timberSlider.cacheSelectors();
  timberSlider.sliders();
};

timberSlider.sliders = function () {
  var $slider = timberSlider.cache.$slider,
      sliderArgs = {
        animation: 'slide',
        animationSpeed: 500,
        pauseOnHover: true,
        keyboard: false,
        slideshow: true,
        slideshowSpeed: 10000,
        smoothHeight: true,
        start: function(slider) {
          // Wrap Previous/Next text in hidden span for accessibility
          $(slider).find('.flex-prev').each(function() {
            var $btn = $(this);
            var text = $btn.text();
            if (text && text.trim() === 'Previous') {
              $btn.html('<span style="display:none">Previous</span>');
            }
          });
          $(slider).find('.flex-next').each(function() {
            var $btn = $(this);
            var text = $btn.text();
            if (text && text.trim() === 'Next') {
              $btn.html('<span style="display:none">Next</span>');
            }
          });
        }
      };

  if ($slider.length) {

    if ($slider.find('li').length === 1) {
      sliderArgs.slideshow = false;
      sliderArgs.slideshowSpeed = 0;
      sliderArgs.controlNav = false;
      sliderArgs.directionNav = false;
      sliderArgs.touch = false;
    }

    $slider.flexslider(sliderArgs);
  }
};

// Initialize slider on docready
$(window).on('load', function() {
  timberSlider.init();
});

window.timberReviewSlider = window.timberReviewSlider || {};

timberReviewSlider.cacheSelectors = function () {
  timberReviewSlider.cache = {
    // Home Page
    $reviewslider: $('#reviewsSlider')
  }
};

timberReviewSlider.init = function () {
  timberReviewSlider.cacheSelectors();
  timberReviewSlider.reviewsliders();
};

timberReviewSlider.reviewsliders = function () {
  var $reviewslider = timberReviewSlider.cache.$reviewslider,
      revewsliderArgs = {
        animation: 'fade',
        animationSpeed: 500,
        pauseOnHover: false,
        keyboard: false,
        slideshow: true,
        slideshowSpeed: 10000,
        smoothHeight: false,
        directionNav: false,
        controlNav: false
      };

  if ($reviewslider.length) {

    if ($reviewslider.find('li').length === 1) {
      revewsliderArgs.slideshow = false;
      revewsliderArgs.slideshowSpeed = 0;
      revewsliderArgs.controlNav = false;
      revewsliderArgs.directionNav = false;
      revewsliderArgs.touch = false;
    }

    $reviewslider.flexslider(revewsliderArgs);
  }
};

// Initialize slider on docready
$(window).on('load', function() {
  timberReviewSlider.init();
});
